import { CrudFormConfig } from 'libs/components/src/lib/utils/edit-form';

export const DYNAMIC_EDIT_FORM_CONFIG: CrudFormConfig = {
  items: [],
  submitButton: { visible: false }
};
